import { pathWithoutId } from './routing';
import {Modal} from 'bootstrap';
import { preload } from './preload';
const $ = jQuery.noConflict();

const LOADING_SPINNER = `
	<div class="evtx-loading fx--spinner">
		<i class="fa fa-circle-o-notch" aria-hidden="true"></i>
	</div>
`

const TOOLTIP_SELECTOR = '[data-toggle="tooltip"]';

const modalId = 'evtx-modal';
const modalEl = document.getElementById(modalId);
const modal = Modal.getOrCreateInstance(modalEl);
const $modal = $(`#${modalId}`);

const EVENT_MODAL_READY = 'views.modal.ready';
const EVENT_MODAL_HIDE = 'views.modal.hide';

window.addEventListener(EVENT_MODAL_READY, function(e) {
   document.body.dispatchEvent(
      new Event('post-load'),
   );
});

export const launchModalWithContent = (content) => {
   insertModalContent(content);
   modal.show();
}

const modalReady = () => {
   const e = new Event(EVENT_MODAL_READY);
   window.dispatchEvent(e);
}


const insertModalContent = (
   content,
   destinationSelector = `#${modalId} .modal-body`,
) => {

   const el = document.querySelector(destinationSelector);
	if (!el) {
		console.warn(`can't find element #${destinationSelector}`);
		return;
	}

	el.innerHTML = content;
   modalReady();
}

export const fetchModalHTML = (postid) => new Promise((resolve, reject) => {
   if (!viewsEventName) {
      return;
   }
   if (!themeSettings) {
      return;
   }
   $.ajax({
      type: 'POST',
      data: {
         action: 'get_modal_html',
         id: postid,
         eventContext: viewsEventName,
         theme: themeSettings,
      },
      url: ajaxurl,
      success: resolve,
      error: function (...args) {
         reject(...args);
			modal.hide();
      },
   });
});

export function fetchAndShowModal(postid) {
   insertModalContent(LOADING_SPINNER);
   modal.show();
   fetchModalHTML(postid)
      .then((data) => {
         $('.evtx-loading').addClass('invisible');
			insertModalContent(data);
      })
      .catch((...args) => {
         console.warn('error!', ...args);
      })
}

export function getPostData(postid) {
   if (!viewsEventName) return;

	insertModalContent(LOADING_SPINNER);
   modal.show();

   $.ajax({
      type: 'POST',
      data: {
         action: 'get_modal_html',
         id: postid,
         eventContext: viewsEventName,
         theme: themeSettings,
      },
      url: ajaxurl,
      success: function (data) {
         $('.evtx-loading').addClass('invisible');
			insertModalContent(data);
      },
      error: function (xhr, status, err) {
			console.warn("Error fetching data from server.")
			modal.hide();
      },
   });
}


export function showPostModal(id) {
   id = id.toString();

   if (!$modal.length) {
      return;
   }
   try {
      if (window.postModalHTML
         && window.postModalHTML[id]
      ) {
         insertModalContent(
            window.postModalHTML[id]
         );
         modal.show();
      }
      else {
         const preloaded = preload.modal.get(id);
         if (preloaded) {
            launchModalWithContent(preloaded);
            modalReady();
         }
         else {
            getPostData(id);
         }
      }
   }
   catch (e) {
      console.warn(e);
      getPostData(id);
   }

   window.lastId = id;
}

export function hideModal(closeModal) {
   history.pushState(
      "",
      document.title,
      pathWithoutId() + location.hash,
   );
   window.lastId = null;
   if (closeModal === true) {
		modal.hide();
      const e = new Event(EVENT_MODAL_HIDE);
      window.dispatchEvent(e);
   }
}

export function setupModalEvents() {

	const modalElement = document.getElementById(modalId);

   // reset hash url when leaving modal window
	modalElement.addEventListener('hidden.bs.modal', function() {
		$(this).find('.wrap-media').html('');
		hideModal();
	});

	modalElement.addEventListener('shown.bs.modal', function() {
		// Initialize AddThis Toolbox, if it exists
      var atSelector = '.addthis_toolbox';
      var $addthis = $(atSelector);
      if ($addthis.length && window.addthis) {
         window.addthis.toolbox(atSelector);
      }
      else {
         $addthis.hide();
      }

		// Setup slick slider galleries within modal
      var $slick = $('#evtx-modal .evtx-gallery');
      if ($slick.length) {
         $slick.slick();
      }
	});



	// TODO: Fix the tooltips!
	modalElement.addEventListener('show.bs.modal', function () {
		// var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		// 	return new bootstrap.Tooltip(tooltipTriggerEl)
		// })
      // $(this).find().tooltip();
      // $(this).find(TOOLTIP_SELECTOR).click(function (event) {
      //    event.stopPropagation();
      // });
	});

   $(function () {
      $(document).on("click", ".evtx-images-open-in-modal img", function (e) {
         e.preventDefault();
         e.stopPropagation();
         var src = $(this).attr('src');
			insertModalContent(`
				<div class="text-center">
					<img class="evtx-image-modal" src="${src}"/>
				</div>`,
			);
			modal.show();
      });
   });


}

/**
 * Pre-loads HTML for post popups
 * @param  {string} jQuery selector
 * @return {null}          stores popup data in object, returns nothing
 */
var modalPostData;
export function storePopupData(selector) {
   if (!viewsEventName) return;
   var allIds = [];
   $(selector).each(function () {
      allIds.push($(this).attr('data-post-id'));
   });

   $.ajax({
      type: 'POST',
      data: {
         action: 'get_modal_html',
         ids: allIds,
         eventContext: viewsEventName,
         theme: themeSettings,
      },
      url: ajaxurl,
      success: function (data) {
         modalPostData = data;
      },
      error: function (xhr, status, err) {
         console.error(this.props.url, status, err.toString());
         modal.hide();
      },
   });
}